import React from 'react'

import Skeleton from '@client/components/Skeleton'

const EmojiPickerLoading = () => {
  return (
    <div>
      <Skeleton width={140} height={30} />
    </div>
  )
}

export default EmojiPickerLoading
